var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-tag",class:_vm.isShowLikeAnimation ? 'add-animation' : '',style:(_vm.setStyle),on:{"click":_vm.likeForBrief}},[_vm._v("\n    "+_vm._s(((_vm.detail.brief) + "(" + (_vm.detail.likeNum) + ")"))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }